module.exports = __webpack_public_path__ + "img/default-logo.b139a807.png";